import { apiClient } from "@/http/apiClient";
import { buildQuery, joinUrl } from "@/http/url";
import Validation from "@/models/Visa";
import { AxiosPromise } from "axios";

// Root path segment for visas
const rootPath = "Visas";

class VisaServices {
  public getTableUrl(idBop: string, lang: string): string {
    return (
      joinUrl(apiClient.defaults.baseURL || "", rootPath) +
      buildQuery({ idBop, lang })
    );
  }
  public getTableUrlForFeb(febId: string, lang: string): string {
    // New API route for FEB-scoped visas
    return (
      joinUrl(apiClient.defaults.baseURL || "", `${rootPath}/byFeb`) +
      buildQuery({ febId, lang })
    );
  }

  // Typed Axios promises (data will be Validation[] or server-defined shape)
  public getVisas(idBop: string, lang: string): AxiosPromise<Validation[]> {
    return apiClient.get<Validation[]>(
      `${rootPath}${buildQuery({ idBop, lang })}`,
    );
  }
  public getVisasByFeb(
    febId: string,
    lang: string,
  ): AxiosPromise<Validation[]> {
    return apiClient.get<Validation[]>(
      `${rootPath}/byFeb${buildQuery({ febId, lang })}`,
    );
  }

  public saveAllVisas(
    visas: Array<Validation>,
    bopId: string,
    lang: string,
  ): AxiosPromise<Validation[]> {
    return apiClient.post<Validation[]>(
      `${rootPath}${buildQuery({ bopId, lang })}`,
      visas,
    );
  }
  public saveAllVisasForFeb(
    visas: Array<Validation>,
    febId: string,
    lang: string,
  ): AxiosPromise<Validation[]> {
    return apiClient.post<Validation[]>(
      `${rootPath}/byFeb${buildQuery({ febId, lang })}`,
      visas,
    );
  }

  public deleteVisa(visaId: string): AxiosPromise<void> {
    return apiClient.delete<void>(`${rootPath}/${visaId}`);
  }

  public getTranslationsUrl(): string {
    return joinUrl(
      apiClient.defaults.baseURL || "",
      rootPath,
      "GetAllTranslations",
    );
  }
  public saveTranslations(data: any): AxiosPromise {
    return apiClient.post(`${rootPath}/translations`, data);
  }
}

export default new VisaServices();
